/* eslint-disable no-unused-vars */ /* eslint-disable react-hooks/exhaustive-deps */ // Controller.js
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Controller;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _ReactModel = /*#__PURE__*/ _interop_require_default(require("./ReactModel"));
const _ReactCanvas = /*#__PURE__*/ _interop_require_default(require("./ReactCanvas"));
const _utilities = require("../../utilities");
const _ANNOTATIONS = require("../lib/ImageInfo/IRVIEWER/ANNOTATIONS.js");
const _MARKERS = require("../lib/ImageInfo/MARKERS.js");
const _temperature = require("../lib/Transforms/temperature.js");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Controller({ id = "irviewer", config = {}, width = 640, height = 480, file = null, interactive = true, settings = {}, temperatureUnits = "F", activeDrawingShape = "", onChange }) {
    var _imageInfo_IRVIEWER;
    const { irmodel, irrenderer, // image payload -->
    imageInfo, imageInfoFrame, images, // palettes -->
    paletteGradient, // flags -->
    isReady } = (0, _ReactModel.default)();
    const [lastSavedImage, setLastSavedImage] = (0, _react.useState)({});
    const [paletteDisplayData, setPaletteDisplayData] = (0, _react.useState)({});
    const settingsCache = (0, _react.useRef)();
    const exportImage = async (...args)=>{
        return await irrenderer.pack(...args);
    };
    const getFormatTemperature = (0, _react.useCallback)((tempCelcius)=>{
        return (0, _temperature.getDisplayTemperature)(tempCelcius, temperatureUnits);
    }, [
        temperatureUnits
    ]);
    const handleImageHasUpdated = ()=>{
        /**
     * ESCAPE HATCH:
     * pass updated image data back up the parent
     *  */ // Pass updated image data back up the parent
        if (lastSavedImage instanceof HTMLImageElement) {
            onChange === null || onChange === void 0 ? void 0 : onChange({
                // unpacked IS2 data
                DATA: {
                    id,
                    img: lastSavedImage,
                    json: imageInfo,
                    photonotes: irrenderer.getPhotonotes(),
                    // callback to export IS2
                    exportImage
                },
                // colorbar and available palette list
                PALETTE_DISPLAY_DATA: _object_spread_props(_object_spread({}, paletteDisplayData), {
                    paletteGradient: paletteGradient
                })
            });
        }
    };
    const storeCanvasImage = (0, _react.useCallback)((img)=>{
        if (img) {
            // Save the current canvas image
            setLastSavedImage(img);
        }
    }, []);
    const irOrientation = (0, _react.useMemo)(()=>(0, _utilities.getIRPaletteSetup)(imageInfoFrame).irOrientation, [
        imageInfoFrame
    ]);
    const globalMarkerVisible = (0, _react.useMemo)(()=>(0, _utilities.getIRVIEWERProps)(imageInfoFrame).globalMarkerVisible, [
        imageInfoFrame
    ]);
    // DATA PROP CHANGES =====================================================
    (0, _react.useEffect)(()=>{
        // if imageInfo or lastSavedImage updates
        handleImageHasUpdated();
    }, [
        imageInfo,
        imageInfoFrame,
        lastSavedImage
    ]);
    (0, _react.useEffect)(()=>{
        // when external data prop has changed or new image-id
        if (!isReady || !file) return;
        // prepare canvas with new rendered images
        irmodel.loadImage(file);
    }, [
        isReady,
        file,
        irmodel
    ]);
    (0, _react.useEffect)(()=>{
        if (isReady) {
            setPaletteDisplayData(irrenderer.getPaletteDisplayData());
        }
    }, [
        isReady,
        irrenderer
    ]);
    // CONFIG PROP CHANGES =====================================================
    const handleSettingsUpdate = (nextSettings = {})=>{
        if (Object.keys(settings).length < 1) return;
        const stringSettings = JSON.stringify(settings);
        const stringSettingsCache = JSON.stringify(settingsCache.current);
        if (stringSettings !== stringSettingsCache) {
            settingsCache.current = nextSettings;
            irmodel.updateSettings(nextSettings);
        }
    };
    (0, _react.useEffect)(()=>{
        var _config_delay;
        // handle updates for renderer settings with optional debounce
        const debouncedUpdate = (0, _utilities.debounce)((settings)=>{
            handleSettingsUpdate(settings);
        }, (_config_delay = config === null || config === void 0 ? void 0 : config.delay) !== null && _config_delay !== void 0 ? _config_delay : 0);
        if (config === null || config === void 0 ? void 0 : config.debounce) {
            debouncedUpdate(settings);
        } else {
            handleSettingsUpdate(settings);
        }
        return ()=>{
            // Clear the timeout when the component unmounts
            debouncedUpdate.cancel();
        };
    }, [
        id,
        settings,
        config === null || config === void 0 ? void 0 : config.debounce,
        config === null || config === void 0 ? void 0 : config.delay,
        irmodel
    ]);
    const handleCursorTemperature = (0, _react.useCallback)((point)=>{
        // CANVAS to RENDERER COORDINATES
        const _point = irmodel.fromCanvasCoordinates(point);
        // PIXEL TEMP uses RENDERER COORDINATES
        const pixelTemp = irrenderer.getPixelTemp(_point);
        // cursor label
        const displayTemperature = getFormatTemperature(pixelTemp);
        return displayTemperature;
    }, [
        getFormatTemperature,
        irmodel,
        irrenderer
    ]);
    const handleOnShapeUpdate = (shape, updateType = "update")=>{
        if (!shape) return;
        shape = _object_spread_props(_object_spread({}, shape), {
            points: shape.points.map((args)=>irmodel.fromCanvasCoordinates(args))
        });
        if (shape.className === "marker") {
            return irmodel.updateShapes(shape, updateType, "MARKERS");
        } else {
            return irmodel.updateShapes(shape, updateType, "ANNOTATIONS");
        }
    };
    var _useMemo;
    const shapes = (_useMemo = (0, _react.useMemo)(()=>{
        var _imageInfo_IRVIEWER;
        if (!isReady) return;
        // flat array of shapes with valid presentation coordinates
        const markers = (0, _MARKERS.flatMarkerArray)(imageInfo === null || imageInfo === void 0 ? void 0 : imageInfo.MARKERS, getFormatTemperature, (args)=>irmodel.toCanvasCoordinates(args));
        // flat array of shapes with valid presentation coordinates
        const annotation = (0, _ANNOTATIONS.flatAnnotationsArray)(imageInfo === null || imageInfo === void 0 ? void 0 : (_imageInfo_IRVIEWER = imageInfo.IRVIEWER) === null || _imageInfo_IRVIEWER === void 0 ? void 0 : _imageInfo_IRVIEWER.ANNOTATIONS, (args)=>irmodel.toCanvasCoordinates(args));
        return [
            ...markers,
            ...annotation
        ];
    }, [
        isReady,
        imageInfo === null || imageInfo === void 0 ? void 0 : imageInfo.MARKERS,
        imageInfo === null || imageInfo === void 0 ? void 0 : (_imageInfo_IRVIEWER = imageInfo.IRVIEWER) === null || _imageInfo_IRVIEWER === void 0 ? void 0 : _imageInfo_IRVIEWER.ANNOTATIONS,
        getFormatTemperature,
        irmodel
    ])) !== null && _useMemo !== void 0 ? _useMemo : [];
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_ReactCanvas.default, {
        // configuration
        config: config,
        container: `container-${id}`,
        width: width,
        height: height,
        // payload
        images: images,
        shapes: shapes,
        // properties
        rotation: irOrientation,
        isMarkerLayerVisible: globalMarkerVisible,
        interactive: interactive,
        activeDrawingShape: activeDrawingShape,
        // events
        onShapeUpdate: handleOnShapeUpdate,
        onCursorUpdate: handleCursorTemperature,
        onSave: storeCanvasImage
    });
}
